module.exports = __webpack_public_path__ + "999a52fe2ed55b9f557f4759a1096026.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/slack-info/slack-info.html
// module id = 1601
// module chunks = 0